import { Button } from "@material-ui/core";
import MyTypography from "@saleor/components/MyTypography";
import PopoverApplyAll from "@saleor/components/PopoverApplyAll";
import { applyAllCheck } from "@saleor/createOrChangeNotRefContract/helpers";
import classNames from "classnames";
import React, { useState } from "react";

const PlantPopOver = ({
  row,
  classes,
  formik,
  isViewMode,
  currentAction,
  orderTypeCashSale,
  isChangeFlow,
  isLinesEmpty
}) => {
  const [openPlant, setOpenPlant] = useState<boolean>(false);
  const [_resetApplyPlant, setResetApplyPlant] = useState<boolean>(false);
  const anchorRef = React.useRef<HTMLButtonElement>(null);

  const handleOnApplyAllPlant = value => {
    setResetApplyPlant(prevState => !prevState);
    formik.setValues(prev => ({
      ...prev,
      lines: prev.lines.map(v => ({
        ...v,
        plant: applyAllCheck(
          value,
          "plant",
          orderTypeCashSale,
          currentAction,
          v,
          isChangeFlow
        )
      }))
    }));

    setOpenPlant(false);
  };
  return (
    <div style={{ position: "relative" }}>
      <MyTypography variant={"subtitle3"} style={{ position: "relative" }}>
        {row.label}
        {!isViewMode && (
          <Button
            id="plantApplyAllDate"
            ref={anchorRef}
            className={classNames(
              classes.buttonApply,
              openPlant && classes.btnApplyOpen
            )}
            variant="contained"
            onClick={() => setOpenPlant(true)}
            disabled={isLinesEmpty}
          >
            Apply all
          </Button>
        )}
        <PopoverApplyAll
          anchorEl={anchorRef.current}
          onClose={() => setOpenPlant(false)}
          open={openPlant}
          onOk={handleOnApplyAllPlant}
          title={"Plant"}
          maxLengthInput={4}
          id="applyAllPlantField"
        />
      </MyTypography>
    </div>
  );
};

export default PlantPopOver;
